import { render, staticRenderFns } from "./Subscription.vue?vue&type=template&id=48be3f66&scoped=true&"
import script from "./Subscription.vue?vue&type=script&lang=js&"
export * from "./Subscription.vue?vue&type=script&lang=js&"
import style0 from "./Subscription.vue?vue&type=style&index=0&id=48be3f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be3f66",
  null
  
)

export default component.exports